import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import humps from 'humps'

import { getToken } from 'utils/general/auth'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    const token = getToken()

    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

export const baseQueryWithCamelize: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions = {}) => {
  const result = await baseQuery(args, api, extraOptions)

  const { data } = result
  if (data) {
    result.data = humps.camelizeKeys(data)
  }

  return result
}

export const stadiumApi = createApi({
  reducerPath: 'stadiumApi',
  baseQuery: baseQueryWithCamelize,
  tagTypes: ['PosAccounts', 'EmployeeRoles'],
  endpoints: () => ({}),
})
